import { useEffect, useState } from "react";
import axios from "axios";
import { Plus, Pencil, Trash2, X, Save } from "lucide-react";
import ImageUploader from "@/components/ImageUploader";

const API = process.env.REACT_APP_BACKEND_URL;
const getHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("bct_token")}` });
const empty = { title: "", subtitle: "", image: "", order: 0 };

export default function AdminSlider() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);

  const load = () => axios.get(`${API}/api/slides`, { headers: getHeaders() }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm(empty); setEditing("new"); };
  const openEdit = (s) => { setForm({ title: s.title, subtitle: s.subtitle, image: s.image, order: s.order }); setEditing(s); };
  const close = () => setEditing(null);

  const handleSave = async () => {
    setLoading(true);
    try {
      if (editing === "new") await axios.post(`${API}/api/admin/slides`, form, { headers: getHeaders(), withCredentials: true });
      else await axios.put(`${API}/api/admin/slides/${editing.id}`, form, { headers: getHeaders(), withCredentials: true });
      close(); load();
    } catch { alert("Hata"); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Silmek istediğinize emin misiniz?")) return;
    await axios.delete(`${API}/api/admin/slides/${id}`, { headers: getHeaders(), withCredentials: true });
    load();
  };

  return (
    <div data-testid="admin-slider">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "Outfit" }}>Slider Yönetimi</h1>
        <button onClick={openNew} className="flex items-center gap-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors" data-testid="add-slide-btn">
          <Plus size={16} /> Yeni Slide
        </button>
      </div>

      <div className="space-y-3">
        {items.map((s) => (
          <div key={s.id} className="bg-[#161923] border border-white/5 rounded-xl p-4 flex items-center gap-4" data-testid={`slide-${s.id}`}>
            <img src={s.image?.startsWith("/api") ? `${API}${s.image}` : s.image} alt="" className="w-24 h-16 rounded-lg object-cover flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-white font-medium text-sm truncate">{s.title}</p>
              <p className="text-slate-500 text-xs truncate">{s.subtitle}</p>
            </div>
            <span className="text-slate-600 text-xs">Sıra: {s.order}</span>
            <div className="flex gap-1">
              <button onClick={() => openEdit(s)} className="p-2 text-slate-400 hover:text-white hover:bg-white/5 rounded-lg"><Pencil size={14} /></button>
              <button onClick={() => handleDelete(s.id)} className="p-2 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="bg-[#161923] border border-white/5 rounded-xl p-12 text-center text-slate-500">Henüz slide eklenmedi. Varsayılan slider gösterilecek.</div>}
      </div>

      {editing !== null && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
          <div className="bg-[#1a1d27] border border-white/10 rounded-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-5 border-b border-white/5">
              <h2 className="text-lg font-bold text-white" style={{ fontFamily: "Outfit" }}>{editing === "new" ? "Yeni Slide" : "Slide Düzenle"}</h2>
              <button onClick={close} className="text-slate-400 hover:text-white"><X size={20} /></button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Başlık</label>
                <textarea value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} rows={2} className="admin-input resize-none" placeholder="Geleceği&#10;İnşa Ediyoruz" data-testid="form-slide-title" />
              </div>
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Alt Başlık</label>
                <input type="text" value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} className="admin-input" data-testid="form-slide-subtitle" />
              </div>
              <ImageUploader value={form.image} onChange={(v) => setForm({ ...form, image: v })} label="Arka Plan Görseli" />
              <div>
                <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Sıra</label>
                <input type="number" value={form.order} onChange={(e) => setForm({ ...form, order: parseInt(e.target.value) || 0 })} className="admin-input" data-testid="form-slide-order" />
              </div>
            </div>
            <div className="flex justify-end gap-3 p-5 border-t border-white/5">
              <button onClick={close} className="px-4 py-2 rounded-lg text-sm text-slate-400 hover:text-white border border-white/10 transition-colors">İptal</button>
              <button onClick={handleSave} disabled={loading || !form.title || !form.image} className="flex items-center gap-2 px-4 py-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white rounded-lg text-sm font-semibold transition-colors disabled:opacity-50" data-testid="form-slide-save">
                <Save size={14} /> {loading ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
